<template>
  <!-- 富文本图片放大组件 -->
  <div class="viewer-dialog-box">
    <div class="img-box">
      <div
        class="img-wrap"
        v-viewer
        ref="viewer">
      <img
        v-for="(src, index) in srcList"
        :src="src"
        :key="index"
        style="width:100%;">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
  },
  data () {
    return {
      srcList: []
    }
  },
  methods: {
    setImgBigger (e) {
      if (e.target.nodeName === 'IMG') {
        // this.ifShowBigger = true // 图片放大器组件开启
        let userAgent = navigator.userAgent // 识别浏览器
        let imgSrc = ''
        if (userAgent.indexOf('Chrome') > -1) {
          imgSrc = e.target.currentSrc // 谷歌
        } else {
          imgSrc = e.target.href // 其他
        }
        this.srcList = [imgSrc]
        const viewer = this.$refs['viewer'].$viewer
        viewer.show()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.viewer-dialog-box {
  z-index: 1001;
  .img-box {
    height: 0px;
    margin: 0 auto;
    .img-wrap {
      width: 0;
      height: 0;
      position: relative;
      cursor: pointer;
      .img-wrap > div {
        height: 100%;
        width: 100%;
      }
      img {
        height: 0;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/ImgViewer.vue